import { render, staticRenderFns } from "./BusinessEmployeeList.vue?vue&type=template&id=2b56d1ed&"
import script from "./BusinessEmployeeList.vue?vue&type=script&lang=js&"
export * from "./BusinessEmployeeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports